export const yr2023 = {
    zelfstandigenaftrek: 5030,
    startersaftrek: 2123,
    mkbVrijstelling: 14,
    zvwBijdrage: { pct: 5.43, limit: 66956 },
    arbeidskorting: [
        { low: 0, high: 10741, pct: 8.231, addition: 0 },
        { low: 10741, high: 23201, pct: 29.861, addition: 884 },
        { low: 23201, high: 37691, pct: 3.085, addition: 4605 },
        { low: 37691, high: 115295, pct: -6.510, addition: 5052 },
        { low: 115295, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 73031, pct: 36.93, addition: 0 },
        { low: 73031, high: 999999999, pct: 49.50, addition: 26970 },
    ],
    heffingskorting: [
        { low: 0, high: 22661, pct: 0, addition: 3070 },
        { low: 22661, high: 73031, pct: -6.095, addition: 3070 },
        { low: 73031, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 73031,
    tarrifaanpassing: 0.1257,
}